



























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { BusyObject } from '@/models/Busy';
import { BrandQueryResult, StoredBrandQuery as StoredBrandQueryData, BrandQueriesService, StoredBrandQueriesService } from '@/api/braendz';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import VerticalBrandTileGrid from '@/components/Brands/VerticalBrandTileGrid.vue';
import HorizontalBrandTileGrid from '@/components/Brands/HorizontalBrandTileGrid.vue';
import BrandDetailsButton from '@/components/Brands/BrandDetailsButton.vue';
import BookmarkBrandButton from '@/components/BrandBookmarks/BookmarkBrandButton.vue';
import MonitorBrandButton from '@/components/Monitoring/MonitorBrandButton.vue';

@Component({
    components: {
        LoadingView,
        VerticalBrandTileGrid,
        HorizontalBrandTileGrid,
        BrandDetailsButton,
        BookmarkBrandButton,
        MonitorBrandButton
    },
    metaInfo() {
        return {
            title: this.$i18n.t("storedBrandQueryResultView.title", { agentName: (this as unknown as StoredBrandQueryResult)?.storedBrandQuery.object?.name ?? this.$i18n.t('storedBrandQueryResultView.agentNameLoading') }).toString(),
        };
    }
})
export default class StoredBrandQueryResult extends Vue {

    // Members:
    public activeQueryResultView = "vertical-view";

    public brandQueryResult = new BusyObject<BrandQueryResult>();
    public storedBrandQuery = new BusyObject<StoredBrandQueryData>();

    // Properties:
    @Prop({ required: true })
    public storedBrandQueryId!: string;

    @Prop({ required: true })
    public resultId!: string;

    // Getter:
    public get isInitializing(): boolean {
        return this.brandQueryResult.isBusy || this.storedBrandQuery.isBusy;
    }
    
    // Lifecycle Methods:
    public mounted(): void {
        this.refreshBrandQueryResult();
        this.refreshStoredBrandQuery();
    }

    // Methods:
    public async refreshBrandQueryResult(): Promise<void> {
        await this.brandQueryResult.load(async () => {
            if(this.resultId) {
                return await BrandQueriesService.getBrandQueryHistoryItemResult(this.resultId);
            } else {
                return null;
            }
        });
    }
    public async refreshStoredBrandQuery(): Promise<void> {
        await this.storedBrandQuery.load(async () => {
            if(!this.storedBrandQueryId) {
                return null;
            }
            else {
                return await StoredBrandQueriesService.getStoredBrandQuery(this.storedBrandQueryId);
            }
        });
    }
}
